<template>
  <v-list-item-content class="pb-0 w-full" @click="$emit('click', $event)">
    <v-layout class="align-center pr-3">
      <v-flex shrink class="px-3">
        <v-icon class="text-core-onCore-lowEmphasis!">{{ icon }}</v-icon>
      </v-flex>
      <v-flex>
        <slot name="title"/>
        <div v-if="$slots.note" class="pt-3 pb-2">
          <slot name="note" />
        </div>
        <span class="date-style mr-2" v-if="date">{{ formatDate(date) }}</span>
        <span class="username font-weight-medium" v-if="userName && $user.isAdminOrVerifier">{{ userName }}</span>
      </v-flex>
    </v-layout>
  </v-list-item-content>
</template>

<script setup lang="ts">
import { dateAndTimeFormat } from '@/composables/useFilters';

interface Props {
  icon?: string
  date?: string
  userName?: string
}

const props = defineProps<Props>()

const formatDate = (date: string) => {
  if (!date) return ''
  return dateAndTimeFormat(date)
}
</script>

<style scoped lang="scss">
.date-style {
  font-size: 14px;
  line-height: 20px;
  opacity: 0.6;
}

.username {
  color: onCoreAlpha($disabled-opacity);
}

p, span {
  & + .date-style {
    display: inline-block;
    margin-top: 8px;
  }
}
</style>
